import type { SyntheticEvent } from "react";

// Bilder aus dem Supabase-Speicher brachen bei vielen gleichzeitigen Anfragen
// gelegentlich ab (kaputtes Bild bzw. Karte blieb leer, nach Neuladen in
// Ordnung; 08.10.2026). Ein einmaliger Neuversuch fängt das ab. Der
// Zusatzparameter erzwingt eine neue Anfrage; die signierte Adresse bleibt
// gültig.

/** onError-Handler: lädt das Bild genau einmal neu. Gibt true zurück, wenn neu geladen wird. */
export function retryImageOnce(event: SyntheticEvent<HTMLImageElement>): boolean {
  const img = event.currentTarget;
  const src = img.getAttribute("src");
  if (!src || img.dataset.retried === "1") return false;
  img.dataset.retried = "1";
  img.src = `${src}${src.includes("?") ? "&" : "?"}retry=1`;
  return true;
}
